/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useLayoutEffect } from 'react';
import Search from '@digital-hig/mui/dist/Search';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { triggerSearchBarClick } from '../common/analyticsApi';

const SearchBox = ({
  result, searchCallback, searchFieldRef, placeHolder,
}) => {
  const [searchValue, setSearchValue] = useState(result?.term || '');
  const [searchItems, setSearchItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    const localTerm = result?.term || '';
    if (localTerm !== searchValue) {
      setSearchValue(localTerm);
    }

    if (window.sessionStorage.getItem('recentSearchItems')) {
      const getCurrentSearchItems = JSON.parse(window.sessionStorage.getItem('recentSearchItems'));
      setSearchItems(getCurrentSearchItems);
    }
  }, [result]);

  const handleInputChange = (event) => {
    if (event?.target) {
      setSearchValue(event.target.innerHTML);
      if (event.target.innerHTML !== '') {
        setOpen(false);
      } else {
        setOpen(true);
      }
    }
  };

  const handleClickedOnOption = (e, value) => {
    setClicked(true);
    setSearchValue(value);
  };

  useEffect(() => {
    if (clicked && searchValue) {
      searchCallback();
    }
  }, [clicked, searchValue]);

  // Search component doesn't allow onClick property
  useLayoutEffect(() => {
    const callback = () => triggerSearchBarClick();
    searchFieldRef.current.addEventListener('click', callback);

    return () => {
      searchFieldRef.current.removeEventListener('click', callback);
    };
  }, []);

  const handleOnFocus = () => {
    setOpen(true);
  };

  const handleOnBlur = () => {
    setOpen(false);
  };

  return (

    <RootElement>
      <form onSubmit={searchCallback}>
        <Search
          id="search"
          label="Search box"
          placeholder={placeHolder || 'Search the learning catalog...'}
          openOnFocus
          value={searchValue}
          ref={searchFieldRef}
          onInputChange={handleInputChange}
          options={searchItems}
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
          open={open}
          onChange={handleClickedOnOption}
        />
      </form>
    </RootElement>
  );
};

const RootElement = styled.div`
    margin-bottom: 24px;
  
    form {
      display: flex;
      max-width: 750px;
      
      & > div {
        flex: 1;
        margin-right: 16px;
        
        div {
          box-shadow: none;
        }
      }
      
      
    }

    .MuiAutocomplete-endAdornment {
      display: none !important;
    }

`;

SearchBox.propTypes = {
  result: PropTypes.shape({ term: PropTypes.string }).isRequired,
  searchCallback: PropTypes.func.isRequired,
  searchFieldRef: PropTypes.shape({
    current: PropTypes.element,
  }).isRequired,
  placeHolder: PropTypes.string,
};

SearchBox.defaultProps = {
  placeHolder: '',
};

export default React.memo(SearchBox);
